<template>
<p>I load data</p>
</template>

<script>
import store from '@/store'

export default {
  name: 'DataLoader',
  data: function () {
      return {
        librariesLoaded: 0,
      }
    },
   computed: {
    lettingFields() {
      return this.$store.state.lettingFields;
    },
    lettingFieldsRoadside() {
      return this.$store.state.lettingFieldsRoadside;
    },
    lettingQuery() {
      return this.$store.state.lettingQuery;
    },
    lettingRoadsideQuery() {
      return this.$store.state.lettingRoadsideQuery;
    },
    lettingLibraries() {
      return this.$store.state.lettingLibraries;
    }
  },
 created: function(){
    this.librariesLoaded = this.lettingLibraries.length;
    
    console.log("Start App.vue loading of lets");
    //  this.loadLetSets("Central Letting");
    // Load all SP Letting data and send that to VUEX store!

    var _lettingLibraries = this.lettingLibraries;
  
    _lettingLibraries.forEach((lettingLibrary) => {
      if(this.librariesLoaded >= 1){
        console.log("Start loading " + lettingLibrary);
        
        this.librariesLoaded--;
    
        this.loadLetSets(lettingLibrary);
      
        console.log("End loading " + lettingLibrary);
      }
    });


 
  },//created()
  methods: {
    loadLetSets: function(lettingLibrary) {
      
   
      $SP().list(lettingLibrary).get({
        fields: this.lettingFields,
        where: this.lettingQuery,
        orderby: "Let_x0020_Date DESC", // Sort newest stuff first, by Let Date
        dateInUTC: true
      }).then(function (data) {

        for (var i = 0; i < data.length; i++) {

            // Trim UniqueId extras parameters
            var _trimmedUniqueID = data[i].getAttribute("UniqueId").match(/\{(.*?)\}/);

            // Lob off weird extra characters at start of FileRef
            // Changes spaces to %20, too
            var _shortFileRef = data[i].getAttribute("FileRef").slice(6).replace(/ /g, "%20");


            // Trim 'Letting' or 'Program' from lettingLibrary string.
            if (lettingLibrary.includes("Letting")) {
                var _shortLibraryName = lettingLibrary.replace(" Letting", "")
            } else if (lettingLibrary.includes("Program")) {
                var _shortLibraryName = lettingLibrary.replace(" Program", "")
            }

            // Build "view the whole let" link, using existing calculated column
            var _trimmedLetLink = data[i].getAttribute("Let").match(/<a([^>]*?)href\s*=\s*(['"])([^\2]*?)\2\1*>/i);
            
            var _thisLet;

            // Only processing Letting Project Document Set content types here
            if (data[i].getAttribute("ContentType") == "Letting Project Document Set") {

                // Add a new object to the letDocSetItems Array.
                var _thisLet = {
                    UniqueId: _trimmedUniqueID[1],
                    Pin: false,
                    id: data[i].getAttribute("ID"),
                    ContentType: data[i].getAttribute("ContentType"),
                    FullLibraryName: lettingLibrary,
                    Division: _shortLibraryName,
                    Overview: ["Test"],
                    Status: data[i].getAttribute("Let_x0020_Status"),
                    LetDate: data[i].getAttribute("Let_x0020_Date"),
                    Let: "<a class='rollup_view_link' href='" + _trimmedLetLink[3] + "'>View<i class='fas fa-external-link-alt'></i></a>",
                    // OpenLet: "<a target='_blank' href='" + _trimmedLetLink[3] + "'>❐</a>",
                    OpenLet: _trimmedLetLink[3],
                    FileRef: _shortFileRef,
                    FileLeafRef: data[i].getAttribute("FileLeafRef"),
                    LetDocSet: data[i].getAttribute("Let_x0020_Doc_x0020_Set"),
                    Project: data[i].getAttribute("Project"),
                    Title: data[i].getAttribute("Title")
                };

                

            } else if (data[i].getAttribute("ContentType") == "Project Letting Documents") {

                // var _fileTitle = data[i].getAttribute("FileLeafRef").slice(6).replace(".pdf", "");

                // var _fileAnchor = '<a class="pdf_rollup_icon" target="_blank" href="/' + _shortFileRef + '">' + _fileTitle + '</a><br />'

                // Add a new object to the itItems Array
                // itbItems.push({
                //     UniqueId: _trimmedUniqueID[1],
                //     id: data[i].getAttribute("ID"),
                //     ContractType: data[i].getAttribute("ContractType"),
                //     ContentType: data[i].getAttribute("ContentType"),
                //     County: data[i].getAttribute("County"),
                //     FullLibraryName: lettingLibrary,
                //     Division: _shortLibraryName,
                //     Status: data[i].getAttribute("Let_x0020_Status"),
                //     LetDate: data[i].getAttribute("Let_x0020_Date"),
                //     Let: _trimmedLetLink[3],
                //     FileRef: _shortFileRef,
                //     FileLeafRef: data[i].getAttribute("FileLeafRef"),
                //     FileAnchor: _fileAnchor,
                //     Project: data[i].getAttribute("Project"),
                //     Title: data[i].getAttribute("Title"),
                // });

            } else {
                console.log('An unexpected file type was returned in SOAP queries.');
            };
    
    
            if(_thisLet.getAttribute("ContentType") == "Letting Project Document Set"){
                store.commit('ADD_LET',_thisLet)
            }
        }
    }).then(function () {
        // updateITBs(lettingLibrary);

    }).catch(function (err) {
        console.error("Connect NCDOT Letting Rollup Failure" + err)
        
        // Error or not, reduce the counter by 1.
        //  libraryLoadCountdown--;

        return false;
    })
  }
  } //methods
} // component
</script>